var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTutorialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#757575"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5231 12.3667C16.6365 13.6617 15.7965 14.07 15.3415 14.8983C15.2248 15.1083 15.1548 15.2717 15.1198 15.6333C15.0615 16.1583 14.5948 16.5433 14.0698 16.5433H13.9998C13.3931 16.5433 12.9148 16.03 12.9731 15.4233C13.0081 15.0267 13.1015 14.6183 13.3231 14.2217C13.8948 13.2067 14.9798 12.6 15.6098 11.7017C16.2748 10.7567 15.9015 8.98333 14.0115 8.98333C13.1831 8.98333 12.6348 9.40333 12.2965 9.905C12.0048 10.325 11.4915 10.5233 11.0131 10.325C10.8698 10.2692 10.741 10.1817 10.6363 10.0689C10.5317 9.95614 10.454 9.82113 10.4091 9.67402C10.3642 9.52691 10.3532 9.37153 10.377 9.21957C10.4008 9.0676 10.4587 8.92301 10.5465 8.79667C11.2581 7.75833 12.4481 7 13.9881 7C15.7148 7 16.8931 7.78167 17.4998 8.77333C18.0131 9.61333 18.3165 11.1883 17.5231 12.3667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0115 21C13.1948 21 12.5415 20.3467 12.5415 19.53C12.5415 18.7017 13.1948 18.0717 14.0115 18.0717C14.8398 18.0717 15.4698 18.7017 15.4698 19.53C15.4581 20.335 14.8398 21 14.0115 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialIcon);
export default __webpack_public_path__ + "static/media/tutorial_icon.5d43b95f7d00831eba146b9a654a08a8.svg";
export { ForwardRef as ReactComponent };